import { useMemo } from "react";

import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { IDemographicsApiParams } from "../types";

export const usePageFilters = (): IDemographicsApiParams => {
    const routeParams = proNavigator.getParams();
    const includeSubdomains = routeParams.includeSubdomains;

    return useMemo(() => {
        const apiParams = proNavigator.getApiParams(routeParams) as IDemographicsApiParams;
        return {
            ...apiParams,
            includeSubdomains,
        };
    }, [includeSubdomains]);
};
